import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import {
  Icon,
  IconButton,
  Button,
  DialogContent,
  Typography,
  DialogTitle,
  Dialog,
  Grid,
  Switch
} from '@material-ui/core';
import {
  ConfirmDialog
} from 'components';
import { updateStoreConfigsApi, getStoreConfigsApi } from 'api';
import { setEditableReferralRule } from 'redux/actions/referral_program';
import RedirectRewardContentDialog from 'components/Dialogs/RedirectRewardContentDialog';
import RewardInfoEditor from '../RewardInfoEditor';
import EditReferralRule from './EditReferralRule';


const customTheme = createTheme({
  overrides: {
    MUIDataTable: {
      root: {
        tableLayout: 'auto',
      }
    }
  }
});

const ReferralProgram = ({
  // setReferralProgramMode,
  products,
  categories
}) =>  {
  const [openEditRuleDialog, setOpenEditRuleDialog] = useState(false);
  const { referralRulesList, editableReferralRule, loadingReferralRules } = useSelector((state) => state.referral_program);
  const {storeConfigs} = useSelector((state) => state.store_configs);
  const dispatch = useDispatch();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [openDialogRewardPage, setOpenDialogRewardPage] = useState(false);

  const [referralConfigValue, setReferralConfigValue] = useState(false);
  const [openRewardInfoEditor, setOpenRewardInfoEditor] = useState(false);

  useEffect(() => {
    if (!storeConfigs.length) {
      getStoreConfigsApi({dispatch});
    }
  }, []);

  useEffect(() => {
    const referralConfig = storeConfigs.find((config) => config.path === 'rewardpoints/referrals/enabled');

    if (referralConfig) {
      setReferralConfigValue(referralConfig.value == 1);
    }
  }, [storeConfigs]);

  const openEditRule = (ruleId) => {
    const editableRule = referralRulesList.find((rule) => rule.rule_id === ruleId);
    dispatch(setEditableReferralRule(editableRule));
    setOpenEditRuleDialog(true);
  };

  const handleUpdateReferralConfigs = () => {
    const configs = [{
      path: 'rewardpoints/referrals/enabled',
      value: referralConfigValue ? '1' : '0'
    }];
    updateStoreConfigsApi({dispatch, configs});
  };

  return (
    <>
      {openRewardInfoEditor ?
        <RewardInfoEditor setOpenRewardInfoEditor={setOpenRewardInfoEditor} />
        :
        <>
          {/* <Button
            className="mr-4"
            variant="contained"
            color="primary"
            onClick={() => setReferralProgramMode(false)}
          >
            <Icon className="mr-2">add</Icon>
            Create New Referral Rule
          </Button> */}
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenRewardInfoEditor(true)}
          >
            <Icon className="mr-2">edit</Icon>
            Edit Rewards Program Content
          </Button>
          <Typography variant="h4" className="my-4">Referral Rules</Typography>
          <Grid container spacing={3} className="ml-2 flex items-center">
            <Grid item xs={12} sm={4} md={3}>Enable Referral Rules:</Grid>
            <Grid item xs={12} sm={8} md={9}>
              <Switch
                color="primary"
                name="rewardpoints/referrals/enabled"
                checked={referralConfigValue}
                onChange={(event) => {
                  setConfirmOpen(true);
                  setReferralConfigValue(event.target.checked);
                }}
              />
            </Grid>
          </Grid>
          <MuiThemeProvider theme={customTheme}>
            <MUIDataTable
              data={referralRulesList}
              columns={[
                {
                  name: 'name',
                  label: 'Referral Rule Name',
                },
                {
                  name: 'is_active',
                  label: 'Status',
                  options: {
                    customBodyRenderLite: (dataIndex) => {
                      const rule = referralRulesList[dataIndex];

                      return (
                        rule.is_active ? 'Active' : 'Inactive'
                      );
                    }
                  }
                },
                {
                  name: 'from_date',
                  label: 'Created At',
                  options: {
                    customBodyRenderLite: (dataIndex) => {
                      const rule = referralRulesList[dataIndex];

                      return (
                        rule.from_date ? rule.from_date : '-'
                      );
                    }
                  }
                },
                {
                  name: 'to_date',
                  label: 'Expired At',
                  options: {
                    customBodyRenderLite: (dataIndex) => {
                      const rule = referralRulesList[dataIndex];

                      return (
                        rule.to_date ? rule.to_date : '-'
                      );
                    }
                  }
                },
                {
                  name: 'Action',
                  lable: 'Action',
                  options: {
                    filter: false,
                    customBodyRenderLite: (dataIndex) => {
                      const rule = referralRulesList[dataIndex];
                      return (
                        <>
                          <IconButton>
                            <Icon onClick={() => openEditRule(rule.rule_id)}>edit</Icon>
                          </IconButton>
                        </>
                      );
                    }
                  }
                }
              ]}
              options={{
                filterArrayFullMatch: false,
                filterType: 'textField',
                responsive: 'standard',
                selectableRows: 'none',
                search: true,
                filter: true,
                download: false,
                print: false,
                pagination: true,
                viewColumns: true,
                elevation: 0,
                rowsPerPage: 20,
                rowsPerPageOptions: [20, 40, 80, 100],
              }}
            />
          </MuiThemeProvider>
          {!!Object.keys(editableReferralRule).length &&
          <Dialog
            open={openEditRuleDialog}
            onClose={() => setOpenEditRuleDialog(false)}
            maxWidth={'lg'}
            fullWidth
          >
            <DialogTitle>
              <Typography variant="h4" className="mt-4">Edit Referral Rule</Typography>
            </DialogTitle>
            <DialogContent  className="m-4">
              <EditReferralRule
                setOpenEditRuleDialog={setOpenEditRuleDialog}
                setOpenDialogRewardPage={setOpenDialogRewardPage}
                loading={loadingReferralRules}
                products={products}
                categories={categories}
              />
            </DialogContent>
          </Dialog>
          }
          <ConfirmDialog
            title="Change Referral Status?"
            open={confirmOpen}
            setOpen={setConfirmOpen}
            onClose={() => setReferralConfigValue(!referralConfigValue)}
            onConfirm={handleUpdateReferralConfigs}
          >
            Are you sure you want to {referralConfigValue ? 'enable' : 'disable'} referral on your store?
          </ConfirmDialog>
          <RedirectRewardContentDialog
            open={openDialogRewardPage}
            setOpen={setOpenDialogRewardPage}
            setOpenRewardInfoEditor={setOpenRewardInfoEditor}
          />
        </>
      }
    </>
  );
};

export default ReferralProgram;
